/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */
import * as References from './ConnectedStatusGraphQLService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#fetch
 */
export const FETCH_QUERY_FIELD_NAME =
  'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_fetch';
export const FETCH_QUERY: RegisteredQuery<
  'result',
  References.FetchRequestType,
  References.FetchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_QUERY_FIELD_NAME,
  args: ['locale', 'statusFetchOptions'],
  fetcher(
    request: References.FetchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.fetchRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#fetchAllForUser
 */
export const FETCH_ALL_FOR_USER_QUERY_FIELD_NAME =
  'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_fetchAllForUser';
export const FETCH_ALL_FOR_USER_QUERY: RegisteredQuery<
  'result',
  References.FetchAllForUserRequestType,
  References.FetchAllForUserResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_ALL_FOR_USER_QUERY_FIELD_NAME,
  args: ['locale', 'statusFetchOptions'],
  fetcher(
    request: References.FetchAllForUserRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchAllForUserResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchAllForUserRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#dismissBatch
 */
export const DISMISS_BATCH_MUTATION_FIELD_NAME =
  'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_dismissBatch';
export const DISMISS_BATCH_MUTATION: RegisteredQuery<
  'result',
  References.DismissBatchRequestType,
  References.DismissBatchResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DISMISS_BATCH_MUTATION_FIELD_NAME,
  args: ['requests'],
  fetcher(
    request: References.DismissBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DismissBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.dismissBatchRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService#dismissBatchForUser
 */
export const DISMISS_BATCH_FOR_USER_MUTATION_FIELD_NAME =
  'com_hubspot_connected_application_status_rpc_frontend_ConnectedStatusGraphQLService_dismissBatchForUser';
export const DISMISS_BATCH_FOR_USER_MUTATION: RegisteredQuery<
  'result',
  References.DismissBatchForUserRequestType,
  References.DismissBatchForUserResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DISMISS_BATCH_FOR_USER_MUTATION_FIELD_NAME,
  args: ['requests'],
  fetcher(
    request: References.DismissBatchForUserRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DismissBatchForUserResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.dismissBatchForUserRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
